export const MARKER_ISOCHRONE_FILTER_KEY = 'marker_isochrone';
export const FREE_ISOCHRONE_FILTER_KEY = 'free_isochrone';
